
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype4 as ObiMosfetNtype4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-4.js';
 
 
 

 
 export const ObiMosfetNtype4 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-4',
   elementClass: ObiMosfetNtype4Element,
   events: {
     
   }
  });
 
 